var noop = function () { return undefined; };
export default noop;
